import { render, staticRenderFns } from "./TranslationEdit.vue?vue&type=template&id=40c41e60&scoped=true&"
import script from "./TranslationEdit.vue?vue&type=script&lang=js&"
export * from "./TranslationEdit.vue?vue&type=script&lang=js&"
import style0 from "./TranslationEdit.vue?vue&type=style&index=0&id=40c41e60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c41e60",
  null
  
)

export default component.exports